import { ethers } from 'ethers';

const toTokenId = (tokenId) => ethers.BigNumber.from(tokenId);

export function toNftTokenIdString(tokenId) {
    return toTokenId(tokenId).toString();
}

export function mapNftTokenIdList(tokenIds) {
    return tokenIds.map((tokenId) => toNftTokenIdString(tokenId));
}

export function buildNftApprovalPlan({ poolAddress, tokenId }) {
    return { method: 'approve', args: [poolAddress, toTokenId(tokenId)] };
}

export function buildNftStakePlan(tokenId) {
    return { method: 'deposit', args: [toTokenId(tokenId)] };
}

export function buildNftWithdrawPlan(tokenId) {
    return { method: 'withdraw', args: [toTokenId(tokenId), ethers.BigNumber.from(1)] };
}

export function buildEmergencyWithdrawPlan() {
    return { method: 'emergencyWithdraw', args: [] };
}

export function buildNftClaimPlan() {
    return { method: 'withdraw', args: [ethers.constants.Zero, ethers.constants.Zero] };
}

export function buildInviteConfigPlan({ rates, isOpen, fee }) {
    return isOpen
        ? { method: 'setInvitorRewardPercentList', args: [rates] }
        : { method: 'openInviter', args: [rates, { value: ethers.utils.parseEther(`${fee}`) }] };
}

export function buildWhitelistPlan(addresses, isAdd) {
    return { method: 'multiWLs', args: [addresses, isAdd] };
}

export function buildSetEmergencyWithdrawPlan(enabled) {
    return { method: 'setUsercanemergencyWithdraw', args: [enabled] };
}

export function buildStopRewardPlan() {
    return { method: 'stopReward', args: [] };
}

export function buildEmergencyRewardWithdrawPlan(amount) {
    return { method: 'emergencyRewardWithdraw', args: [amount] };
}

export function parseManualNftTokenId(tokenId) {
    if (typeof tokenId !== 'string' || tokenId.trim() === '') {
        return { valid: false, reason: 'missing' };
    }

    if (!/^\d+$/.test(tokenId)) {
        return { valid: false, reason: 'invalid' };
    }

    const parsedTokenId = ethers.BigNumber.from(tokenId);
    if (parsedTokenId.gt(ethers.constants.MaxUint256)) {
        return { valid: false, reason: 'invalid' };
    }

    return {
        valid: true,
        tokenId: parsedTokenId,
        tokenIdString: parsedTokenId.toString(),
    };
}

export function isManualNftOwner({ owner, wallet }) {
    return Boolean(owner && wallet && owner.toLowerCase() === wallet.toLowerCase());
}

export function isDuplicateManualNft({ tokenId, existingNfts }) {
    const normalizedTokenId = toTokenId(tokenId);
    return existingNfts.some((item) => {
        try {
            return toTokenId(item.id).eq(normalizedTokenId);
        } catch (_error) {
            return false;
        }
    });
}

export async function runNftStakeAfterApproval({ approve, stake }) {
    try {
        if (!(await approve())) return false;
        await stake();
        return true;
    } catch (_error) {
        return false;
    }
}
